import { DataGrid } from "@mui/x-data-grid";
import NoDataImg from "../Common/NoDataImage";
import { TablePagination } from "@mui/material";

function DataListingComponent(props) {
  const {
    data,
    loading,
    columns,
    totalData,
    page,
    handlePageChange,
    rowsPerPage,
    handleRowsPerPageChange,
    PAGE_SIZE_OPTIONS,
    Footer,
    onRowClick
  } = props;

  return (
    <> 
      <DataGrid
        rows={data}
        pagination
        loading={loading}
        hideFooter
        disableColumnMenu={true}
        disableAutosize={true}
        slots={{ noRowsOverlay: NoDataImg }}
        disableColumnFilter={true}
        columns={columns}
        onRowClick={onRowClick}
        hideFooterSelectedRowCount={true}
        getRowId={(e) => e?.id}
        slotProps={{
          loadingOverlay: {
            variant: "skeleton",
            noRowsVariant: "skeleton",
          },
        }}
        sx={{
          borderRadius: "12px",
          cursor: "pointer",
          ".MuiDataGrid-cell": {
            textAlign: "center",
            background: "#ffffff",
            "&:focus": { outline: "none" },
          },
          ".MuiDataGrid-columnHeaderTitle": {
            fontWeight: "600",
            color: `#164FA1`,
          },
          "& .super-app-theme--header": {
            // background: `#DEE6F2`,
            background: `#DEE6F2`,
            // background: theme.palette.primary.Blend,
          },
        }}
        pageSize={rowsPerPage}
      />

      {Footer && (
        <TablePagination
          component="div"
          count={totalData}
          page={page}
          onPageChange={handlePageChange}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={handleRowsPerPageChange}
          rowsPerPageOptions={PAGE_SIZE_OPTIONS}
        />
      )}
    </>
  );
}

export default DataListingComponent;
